export function getRandomInteger() {
    const array = new Uint32Array(1);
    return window.crypto.getRandomValues(array)[0];
}